var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container type-1 ordering"},[_c('main',{staticClass:"form-main"},[_c('h2',[_vm._v("Оформление заявки")]),_c('request-form')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }